/** Returns true when a tag value is blank: null, undefined, empty string, or empty array. */
export function isTagEmpty(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
}